const initialState = {
    customer_search_list: [],
    customer_search_task_list: [],
    customer_data: [],
    customer_quote_data: [],
    loading: false,  // Add loading state
};

const customerSearchReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'START_LOADING':
            return { ...state, loading: true };

        case 'STOP_LOADING':
            return { ...state, loading: false };

        case 'CUSTOMER_SEARCH_LIST_SUCCESS':
        return {
            ...state,
            customer_search_list: action.payload || [],
            loading: false,  // Stop loading when data is fetched
        };
        case 'CLEAR_CUSTOMER_SEARCH_LIST_SUCCESS':
        return {
            ...state,
            customer_search_list: [],
            loading: false,  // Stop loading when data is fetched
        };
         case 'CUSTOMER_SEARCH_TASK_LIST_SUCCESS':
            return {
                ...state,
                customer_search_task_list: action.payload || [],
                loading: false,  // Stop loading when data is fetched
            };

        case 'GET_CUSTOMER_DATA_SUCCESS':
            return {
                ...state,
                customer_data: action.payload || [],
                loading: false,
            };
      case 'GET_CUSTOMER_POICY_CLEAR_DATA_SUCCESS':
            return {
                ...state,
                customer_data: [],
                loading: false,
            };

        case 'GET_CUSTOMER_QUOTE_LIST_DATA_SUCCESS':
            return {
                ...state,
                customer_quote_data: action.payload || [],
                loading: false,
            };
        case 'RESET_GLOBAL_SEARCH_LOADING':
            return {
                 ...state,
        loading: false
            }
        case 'CUSTOMER_SEARCH_LIST_FAILURE':
        case 'GET_CUSTOMER_DATA_FAILURE':
        case 'GET_CUSTOMER_QUOTE_LIST_DATA_FAILURE':
            return { ...state, error: action.payload, loading: false };

        default:
            return state;
    }
};

export default customerSearchReducer;
